export const visit = (vm, at) => {
vm(require("foundations-components/lang/no.lyaml"));
at({ "no-no": { "placeholder": "plassholder" } });
};